module.exports = __webpack_public_path__ + "static/media/mernstack.6a1388db.png";